import { Button } from '@mui/material';
import { doPost } from '@app/api';
import { ClinicsTableView } from '../models';

interface ArchiveClinicButtonProps {
  ids: string[];
  view: ClinicsTableView;
  fetch: VoidFunction;
}

export function ArchiveClinicButton({ ids, view, fetch }: ArchiveClinicButtonProps) {
  const isActiveView = view === ClinicsTableView.ACTIVE;

  const handleClick = async () => {
    if (ids.length) {
      try {
        await doPost('api/clinics/archive', {
          ids,
          archive: isActiveView,
        });

        fetch();
      } catch (e) {
        console.log('e', e);
      }
    }
  };

  return (
    <>
      <Button
        variant='outlined'
        color={isActiveView ? 'error' : 'success'}
        onClick={handleClick}
        size='small'
        disabled={!ids?.length}
      >
        {isActiveView ? 'В архив' : 'В активные'}
      </Button>
    </>
  );
}
